/**
 * Test IDs for QA automation.
 */
export const testIds = {
  lynksTableRow: "lynks-table-row",
  lynksTableBooleanField: "lynks-table-boolean-field",
  lynksTableSelectRow: "lynks-table-select-row",
  lynksTableEdit: "lynks-table-edit",
  lynksTableLabeledRowAction: "lynks-table-labeled-row-action",
  lynksTableIconRowAction: "lynks-table-icon-row-action",
  lynksTableDelete: "lynks-table-delete",
  lynksTableMoreActions: "lynks-table-more-actions",
  lynksTableSearch: "lynks-table-search",
  lynksTableRowActionMenuOption: "lynks-table-row-action-menu-option",
  lynksTableRowActionMenuIcon: "lynks-table-row-action-menu-icon",
  lynksTableToggleChildRows: "lynks-table-toggle-child-rows",
} as const;
